<div data-automation-id="epub-controls" role="group" aria-label="Media Controls">
  <div *ngIf="enableTTS" class="button-group">
    <rdrx-page-tts-controls class="tts-controls"></rdrx-page-tts-controls>
  </div>

  <div
    *ngIf="showReadSpeakerVoicePick"
    class="button-group button-voice-picker"
  >
    <rdrx-tts-voice-picker></rdrx-tts-voice-picker>
  </div>

  <!-- AI READER SECTION -->
  <div *ngIf="isAiAssistOffered && !isAiSummaryOffered" class="button-group button-group-sm ai-assist">
    <button
      data-automation-id="epub-controls-ai-assist-button"
      mhe-button
      class="aiAssistButton"
      id="ai-assist-button-control"
      aria-controls="ngx-ai-assist-panel"
      [attr.aria-label]="'ai_tools.reader.button' | translate"
      [attr.aria-expanded]="isAiAssistOpen$ | async"
      [purpose]="ButtonPurpose.Icon"
      (click)="onClickAiAssist()"
      [mheTooltip]="'ai_tools.reader.button' | translate"
      placement="left"
    >
      <i class="ai-assist ai-assist-icon bigger"></i>
    </button>
  </div>

  <!-- AI TOOLS SECTION - this is separate from the AI Assist button to allow for expansion of AI tools offered without overwhelming the user with too many buttons at once -->
  @if (featureTogglesService.learningStudioEnabled$ | async) {
    <div *ngIf="isAiAssistOffered && isAiSummaryOffered" class="button-group button-group-sm ai-tools" (focusout)="onAiToolsFocusOut($event)">
      <button
        data-automation-id="epub-controls-ai-tools-button"
        mhe-button
        class="aiToolsButton"
        id="ai-tools-button-control"
        aria-controls="ngx-ai-tools-panel"
        [attr.aria-label]="'ai_tools.button' | translate"
        (click)="openAITools()"
        [attr.aria-expanded]="isAiToolsOpen()"
        [purpose]="ButtonPurpose.Icon"
        [mheTooltip]="'ai_tools.button' | translate"
        placement="left"
        rdrxHideOnEscape
      >
        <img
          id='ai-tools'
          src="/assets/icons/reader/ai-tools.svg"
          alt="AI Tools Icon"
          width="20px"
        />
      </button>

      <!-- AI Tools Floating Panel -->
      @if (isAiToolsOpen()) {
        <div
          id="ngx-ai-tools-panel"
          class="ai-tools-panel"
          cdkMenu
        >
          <button
            data-automation-id="epub-controls-ai-summary-button"
            mhe-button
            cdkMenuItem
            aria-controls="ngx-ai-summary-panel"
            [attr.aria-label]="'ai_tools.summary.button' | translate"
            (cdkMenuItemTriggered)="onAiSummaryClick()"
            [mheTooltip]="'ai_tools.summary.button' | translate"
            [purpose]="ButtonPurpose.Icon"
            placement="left"
            rdrxHideOnEscape
          >
            <img
              id='ai-summary'
              src="/assets/icons/reader/ai-summary.svg"
              alt="AI Summary Icon"
              width="24px"
            />
            <span class="ai-label">{{ 'ai_tools.summary.title' | translate }}</span>
          </button>

          <button
            data-automation-id="epub-controls-ai-reader-button"
            mhe-button
            cdkMenuItem
            id="ai-assist-menu-item-control"
            aria-controls="ngx-ai-assist-panel"
            [attr.aria-label]="'ai_tools.reader.button' | translate"
            [attr.aria-expanded]="isAiAssistOpen$ | async"
            (cdkMenuItemTriggered)="onClickAiAssist()"
            [mheTooltip]="'ai_tools.reader.button' | translate"
            [purpose]="ButtonPurpose.Icon"
            placement="left"
            rdrxHideOnEscape
          >
            <i class="ai-assist ai-assist-icon"></i>
            <span class="ai-label">{{ 'ai_tools.reader.title' | translate }}</span>
          </button>
        </div>
      }
    </div>

    <div *ngIf="!isAiAssistOffered && isAiSummaryOffered" class="button-group button-group-sm ai-summary">
      <button
        mhe-button
        data-automation-id="epub-controls-ai-summary-button"
        class="aiSummaryButton"
        id="ai-summary-button-control"
        aria-controls="ngx-ai-summary-panel"
        [attr.aria-label]="'ai_tools.summary.button' | translate"
        [purpose]="ButtonPurpose.Icon"
        (click)="onAiSummaryClick()"
        [mheTooltip]="'ai_tools.summary.button' | translate"
        placement="left"
      >
        <img
          id='ai-summary-control'
          src="/assets/icons/reader/ai-summary.svg"
          alt="AI Summary Icon"
          width="20px"
        />
      </button>
    </div>
  }
</div>

<div class="button-group button-group-sm" *ngIf="readerStore.showAnnotateButton$ | async">
  <button
    data-automation-id="epub-controls-annotate-mobile-button"
    mhe-button
    [purpose]="ButtonPurpose.Icon"
    (click)="annotateSelectionOnMobile()"
    [mheTooltip]="'navigation.highlight_button' | translate"
  >
    <i class="dpg-icon dpg-icon-highlighter"></i>
  </button>
</div>

<div *ngIf="isFixedLayout || (isFplSpine$ | async)" class="button-group bottom-button-group">
  <button
    data-automation-id="epub-controls-album-mode-button"
    *ngIf="isDoubleSpread && (ribac$ | async) === false && isSinglePageViewOnly === false"
    [disabled]="isAlbumModeForced$ | async"
    mhe-button
    [purpose]="ButtonPurpose.Icon"
    [mheTooltip]="albumModeLabel"
    (click)="onToggleAlbumMode()"
  >
    <i
      class="dpg-icon"
      [class.dpg-icon-box-one-arrow-in-left]="!albumMode"
      [class.dpg-icon-boxes-two-arrow-in-left]="albumMode"
    ></i>
  </button>

  <ng-container *ngIf="albumMode || !isDoubleSpread">
    <button
      data-automation-id="epub-controls-zoom-in-button"
      [disabled]="!increaseEpubZoomEnabled"
      mhe-button
      [purpose]="ButtonPurpose.Icon"
      [mheTooltip]="'iframe.zoom_in_page' | translate"
      (click)="increaseZoomLevel()"
    >
      <i class="dpg-icon dpg-icon-magnifying-glass-plus-symbol"></i>
    </button>

    <p class="zoom-display" data-automation-id="epub-controls-zoom-display" [attr.aria-label]="'iframe.zoom_level' | translate" aria-live="polite">{{ zoomDisplay }}</p>

    <button
      data-automation-id="epub-controls-zoom-out-button"
      [disabled]="!decreaseEpubZoomEnabled"
      mhe-button
      [purpose]="ButtonPurpose.Icon"
      [mheTooltip]="'iframe.zoom_out_page' | translate"
      (click)="decreaseZoomLevel()"
    >
      <i class="dpg-icon dpg-icon-magnifying-glass-minus-symbol"></i>
    </button>

    <ng-container *ngIf="zoomLevel > 1">
      <button
        data-automation-id="epub-controls-move-up-button"
        class="btn-arrow-icon"
        mhe-button
        [disabled]="!enableUpArrow"
        [purpose]="ButtonPurpose.Icon"
        (click)="moveEpubOnClick('up')"
        [mheTooltip]="'iframe.move_page_up' | translate"
      >
        <i class="dpg-icon dpg-icon-up-arrow"></i>
      </button>

      <button
        data-automation-id="epub-controls-move-down-button"
        class="btn-arrow-icon"
        mhe-button
        [disabled]="!enableDownArrow"
        [purpose]="ButtonPurpose.Icon"
        (click)="moveEpubOnClick('down')"
        [mheTooltip]="'iframe.move_page_down' | translate"
      >
        <i class="dpg-icon dpg-icon-down-arrow"></i>
      </button>

      <button
        data-automation-id="epub-controls-move-right-button"
        class="btn-arrow-icon"
        mhe-button
        [disabled]="!enableRightArrow"
        [purpose]="ButtonPurpose.Icon"
        (click)="moveEpubOnClick('right')"
        [mheTooltip]="'iframe.move_page_right' | translate"
      >
        <i class="dpg-icon dpg-icon-right-arrow"></i>
      </button>

      <button
        data-automation-id="epub-controls-move-left-button"
        class="btn-arrow-icon"
        mhe-button
        [disabled]="!enableLeftArrow"
        [purpose]="ButtonPurpose.Icon"
        (click)="moveEpubOnClick('left')"
        [mheTooltip]="'iframe.move_page_left' | translate"
      >
        <i class="dpg-icon dpg-icon-system-left-arrow"></i>
      </button>
    </ng-container>
  </ng-container>
</div>
